module.exports = __webpack_public_path__ + "img/title-5.444d848b.png";